// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTable-IconSpacer_cls1__fCi9k","cls2":"VeloTable-IconSpacer_cls2__mZI2j VeloTable-IconSpacer_cls1__fCi9k"};